import { useTheme } from '@emotion/react'
import { HashLoader } from 'react-spinners'

const Loader = () => {
  const theme = useTheme()
  return <HashLoader color={theme.loader.loaderColor} />
}

export default Loader
